import getSnippetInstance from '../zend-desk/get-snippet-instance';

const hideForm = async () => {
  const widget = await getSnippetInstance();
  widget.hide();
};

export default hideForm;
